/**
 * PageHeader - Unified page title + icon + subtitle + actions
 * 
 * Usage:
 *   <PageHeader 
 *     icon={Briefcase}
 *     title="Dashboard" 
 *     subtitle="Welcome back" 
 *     actions={<Button>Action</Button>} 
 *   />
 */

export function PageHeader({ 
  icon: Icon,
  title, 
  subtitle, 
  actions,
  className = ''
}) {
  return (
    <div className={`mb-8 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <div className="flex items-center gap-2.5">
            {Icon && <Icon className="w-6 h-6 text-brand flex-shrink-0" />}
            <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
              {title}
            </h1>
          </div>
          {subtitle && (
            <p className={`mt-1 text-sm sm:text-base text-slate-500 ${Icon ? 'ml-[34px]' : ''}`}>
              {subtitle}
            </p>
          )}
        </div>
        
        {actions && (
          <div className="flex items-center gap-3 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
